






























































































































































































































































































































































































import { Component, Prop, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import BaseSuketCard from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketCard.vue";
import StoreSuketMcuUmum from "@/store/modules/SuketMcuUmum";
import CommonSuket, { EnSuketCategory } from "@/services/CommonSuket";
import BaseSuketTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketTabPage";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import { getAge, formatDMYDate } from "@/utility/DateUtils";
import { storeDokter } from "@/store/modules/dokter";
import {
  SuketBaseWithRelationship,
  ContentInterface
} from "@/types/suket_mcu_umum";

import pdf from "vue-pdf";

function emptyContent(): ContentInterface {
  return {
    fisik: {
      td_sistolik: null,
      td_diastolik: null,
      nadi: null,
      tb: null,
      bb: null,
      imt: null,
      gol_darah: null,
      rhesus: null
    },
    laboratorium: {
      terlampir: null,
      catatan: null
    },
    radiologi: [""],
    penunjang: {
      ekg: null,
      spirometri: null,
      audiometri: null,
      lain: null
    },
    poliklinik: [
      { spesialis: null, hasil: null },
      { spesialis: null, hasil: null },
      { spesialis: null, hasil: null }
    ],
    kesimpulan: [""],
    kesimpulan_status: null,
    kesimpulan_catatan: null,
    saran: [""]
  };
}

@Component({
  components: { CardModalTtd, BaseSuketCard, pdf }
})
export default class SuketMcuUmumTabPage extends BaseSuketTabPage {
  @Prop() declare readonly register: string | number;

  // Visible di semua poli ralan — MCU Umum tidak terbatas unit gigi.
  allowedUnit = ["*"];
  suketSvc = new CommonSuket(EnSuketCategory.McuUmum);
  suketStore = StoreSuketMcuUmum;

  register_id = this.register;
  pasien_rm = this.pasien.rm;
  unit_id = this.user.unit_id;
  umur = getAge(formatDMYDate(this.pasien.tgl_lahir)).toString().concat(" Th");
  surat_date = new Date();
  signee_user_id = this.user.id;
  creator_user_id = this.user.id;

  content: ContentInterface = emptyContent();

  saving = false;
  loadedRatio = 0;

  golDarahOpts = [
    { text: "A", value: "A" },
    { text: "B", value: "B" },
    { text: "AB", value: "AB" },
    { text: "O", value: "O" },
    { text: "Belum diperiksa", value: "belum_diperiksa" }
  ];

  rhesusOpts = [
    { text: "Rh + (positif)", value: "positif" },
    { text: "Rh – (negatif)", value: "negatif" },
    { text: "Belum diperiksa", value: "belum_diperiksa" }
  ];

  statusOpts = [
    { text: "SEHAT", value: "SEHAT" },
    { text: "SEHAT DENGAN CATATAN", value: "SEHAT DENGAN CATATAN" },
    { text: "TIDAK SEHAT", value: "TIDAK SEHAT" }
  ];

  rRequired = [(v: any) => (v !== null && v !== undefined && v !== "") || "*Kolom ini harus diisi"];
  rRequiredNumber = [
    (v: any) => (typeof v === "number" && !isNaN(v)) || "*Wajib angka"
  ];
  rCatatan = [
    (v: any) => !!v || "*Catatan klinis wajib (KODEKI Psl 7)",
    (v: any) => (v || "").length >= 30 || "Minimal 30 karakter"
  ];

  mounted() {
    this.fillFromData(this.dataSuket);
  }

  get pasien() {
    return storePasien.identitasPasien;
  }

  get user() {
    return userModule.user;
  }

  get listDokter() {
    return storeDokter.list;
  }

  get canSign() {
    return this.user.id == this.signee_user_id;
  }

  get pdfUrl() {
    return this.dataSuket
      ? this.getSuketPdfUrl(EnSuketCategory.McuUmum, this.dataSuket.id)
      : null;
  }

  get input() {
    return {
      register_id: this.register_id,
      pasien_rm: this.pasien_rm,
      unit_id: this.unit_id,
      content: this.content,
      surat_date: this.surat_date,
      signee_user_id: this.signee_user_id,
      creator_user_id: this.creator_user_id
    };
  }

  // FE preview IMT (server tetap source of truth via recomputeImt()).
  get imtPreviewLabel() {
    const bb = Number(this.content.fisik.bb || 0);
    const tb = Number(this.content.fisik.tb || 0);
    if (bb <= 0 || tb <= 0) return "-";
    const tbM = tb / 100;
    const imt = bb / (tbM * tbM);
    const r = Math.round(imt * 10) / 10;
    let interp = "normal";
    if (r < 18.5) interp = "berat kurang";
    else if (r >= 25 && r < 27) interp = "berat lebih";
    else if (r >= 27) interp = "obesitas";
    return `${r} (${interp})`;
  }

  fillFromData(val: SuketBaseWithRelationship) {
    if (val) {
      this.register_id = val.register_id;
      this.pasien_rm = val.pasien_rm.toString();
      this.unit_id = val.unit_id;
      this.umur = (val.pasien as any)?.umur_th || this.umur;
      this.surat_date = (val.surat_date as any) ?? new Date();
      this.signee_user_id = val.signee_user_id;
      this.creator_user_id = val.creator_user_id;
      this.content = { ...emptyContent(), ...((val.content as any) || {}) } as ContentInterface;
    } else {
      this.register_id = this.register;
      this.pasien_rm = this.pasien.rm;
      this.unit_id = this.user.unit_id;
      this.umur = getAge(formatDMYDate(this.pasien.tgl_lahir)).toString().concat(" Th");
      this.surat_date = new Date();
      this.signee_user_id = this.user.id;
      this.creator_user_id = this.user.id;
      this.content = emptyContent();
    }
  }

  addRadiologi() { this.content.radiologi.push(""); }
  removeRadiologi(i: number) { this.content.radiologi.splice(i, 1); }
  addPoliklinik() { this.content.poliklinik.push({ spesialis: null, hasil: null }); }
  removePoliklinik(i: number) { this.content.poliklinik.splice(i, 1); }
  addKesimpulan() { this.content.kesimpulan.push(""); }
  removeKesimpulan(i: number) { this.content.kesimpulan.splice(i, 1); }
  addSaran() { this.content.saran.push(""); }
  removeSaran(i: number) { this.content.saran.splice(i, 1); }

  save() {
    if (this.saving) return;
    this.saving = true;

    const action = this.dataSuket
      ? this.suketSvc.update(this.dataSuket.id, this.input)
      : this.suketSvc.create(this.input);

    action
      .then(() => {
        if (this.canSign) {
          this.showSignatureModal();
        }
        appModule.NoticeDelay("Berhasil Simpan MCU Umum");
        this.close();
        StoreSuketMcuUmum.getSuketByRegister(this.register);
      })
      .finally(() => {
        this.saving = false;
      });
  }

  close() {
    this.expandInput = false;
  }

  @Watch("dataSuket")
  changeDataSuket(val: SuketBaseWithRelationship) {
    this.fillFromData(val);
  }
}
